<template>
  <div>
    <Page :title="pageTitle">
      <template v-slot:default>
        <div class="my-2">
          <div class="">
            <h3 class="text-base leading-6 font-medium text-gray-900 my-2">
              Selete Date
            </h3>
            <DateRangePicker
              v-model="currentConfig"
              opens="right"
              :ranges="ranges"
              @update="dateSelected"
            />
            <div v-if="isLoading">
              <Spinner />
            </div>
            <h3 class="text-lg leading-6 font-medium text-gray-900 mt-4">
              {{ dateDiff }}
            </h3>
            <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
              Abandoned carts
            </h3>
            <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Messages sent
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ checkoutReport.totalMessagesSent }}
                    </dd>
                  </dl>
                </div>
              </div>

              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Carts recovered
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ checkoutReport.cartsRecovered }}
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Cart value recovered
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ checkoutReport.cartsRecoveredValue }}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
              Chat & share
            </h3>
            <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Chat clicked
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ chatReport.chatClicks }}
                    </dd>
                  </dl>
                </div>
              </div>

              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Share Clicked
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ chatReport.shareClicks }}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>

            <div class="Polaris-LegacyCard mt-4">
              <div class="Polaris-MediaCard">
                <div
                  class="Polaris-MediaCard__MediaContainer Polaris-MediaCard--sizeSmall"
                >
                  <img
                    alt=""
                    width="100%"
                    height="100%"
                    style="object-fit:cover;object-position:center"
                    src="https://cdn.shopify.com/app-store/listing_images/8fc5f6d4d41f33cfcf0ebc61d01b572a/icon/CN2aot70lu8CEAE=.png"
                  />
                </div>
                <div
                  class="Polaris-MediaCard__InfoContainer Polaris-MediaCard--sizeSmall"
                >
                  <div class="Polaris-LegacyCard__Section">
                    <!-- <div class="Polaris-MediaCard__Popover">
                      <div>
                        <button
                          class="Polaris-Button Polaris-Button--plain Polaris-Button--sizeSlim Polaris-Button--iconOnly"
                          aria-label="Actions"
                          type="button"
                          tabindex="0"
                          aria-controls="Polarispopover1"
                          aria-owns="Polarispopover1"
                          aria-expanded="false"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Icon">
                              <span class="Polaris-Icon">
                                <span
                                  class="Polaris-Text--root Polaris-Text--visuallyHidden"
                                >
                                </span>
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M6 10a2 2 0 1 1-4.001-.001 2 2 0 0 1 4.001.001zm6 0a2 2 0 1 1-4.001-.001 2 2 0 0 1 4.001.001zm6 0a2 2 0 1 1-4.001-.001 2 2 0 0 1 4.001.001z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                        </button>
                      </div>
                    </div> -->
                    <div
                      class="Polaris-LegacyStack Polaris-LegacyStack--vertical Polaris-LegacyStack--spacingTight"
                    >
                      <div class="Polaris-LegacyStack__Item">
                        <div class="Polaris-MediaCard__Heading">
                          <h2
                            class="Polaris-Text--root Polaris-Text--headingMd"
                          >
                            Automated abandoned cart recovery
                          </h2>
                        </div>
                      </div>
                      <div class="Polaris-LegacyStack__Item">
                        <p>
                          Send reminders to abandoned checkouts on WhatsApp to
                          convert more orders
                        </p>
                      </div>
                      <div class="Polaris-LegacyStack__Item">
                        <div class="Polaris-MediaCard__ActionContainer">
                          <div class="Polaris-ButtonGroup">
                            <div class="Polaris-ButtonGroup__Item">
                              <div class="Polaris-MediaCard__PrimaryAction">
                                <button
                                  class="Polaris-Button"
                                  type="button"
                                  @click="gotoAutomation"
                                >
                                  <span class="Polaris-Button__Content">
                                    <span class="Polaris-Button__Text"
                                      >Setup Automation</span
                                    >
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <OnboardingChecklist class="my-4" />
            <!-- <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
              Automation
            </h3>
            <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Abandoned messages sent
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ checkoutReport.automatedMessages }}
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Order confirmation messages sent
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ automationReport.orderConfirmationMessagesSent }}
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Order shipping updates sent
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ automationReport.orderShippingUpdatesSent }}
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      COD messages sent
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ automationReport.codConfirmationMessagesSent }}
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Review requests sent
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ automationReport.reviewRequestsSent }}
                    </dd>
                  </dl>
                </div>
              </div>
              <div
                v-if="config.storeId === '61a59576119cfa2c9e4772b3'"
                class="bg-white overflow-hidden shadow rounded-lg"
              >
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-gray-500 ">
                      Short links clicked
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ urlReport.clickedCount }}
                    </dd>
                  </dl>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";

import OnboardingChecklist from "../components/Onboarding/OnboardingChecklist.vue";

import Spinner from "vue-simple-spinner";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { Redirect } from "@shopify/app-bridge/actions";

// import ReviewUs from "../components/Common/ReviewUs";

import {
  subDays,
  format,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth
} from "date-fns";

export default {
  name: "Analytics",
  components: {
    Page,
    DateRangePicker,
    Spinner,
    // ReviewUs,
    OnboardingChecklist
  },
  data() {
    return {
      pageTitle: "Overview",
      report: {},
      chatReport: {},
      checkoutReport: {},
      automationReport: {},
      urlReport: {},
      clickedCount: {},
      currentConfig: {
        startDate: "",
        endDate: ""
      },
      ranges: {},
      isLoading: false
    };
  },
  computed: {
    dateDiff() {
      const startDate = this.currentConfig.startDate;
      const endDate = this.currentConfig.endDate;

      if (startDate && endDate) {
        return `${format(startDate, "dd MMM yyyy")} - ${format(
          endDate,
          "dd MMM yyyy"
        )}`;
      }
      return "";
    },
    config() {
      return this.$store.getters.getConfig;
    }
  },
  async created() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    this.ranges = {
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
      "This month": [startOfMonth(today), endOfMonth(today)],

      "Last month": [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0)
      ]
    };
  },
  mounted() {
    const startDate = subDays(new Date(), 7);
    this.currentConfig = {
      startDate: startDate,
      endDate: new Date()
    };
    this.getReport();
  },
  methods: {
    dateSelected() {
      this.getReport();
    },
    async getReport() {
      this.isLoading = true;
      const startDate =
        startOfDay(this.currentConfig.startDate).getTime() / 1000;
      const endDate = endOfDay(this.currentConfig.endDate).getTime() / 1000;
      const response = await this.$store.dispatch("getAnalytics", {
        startDate,
        endDate
      });
      this.report = response;
      this.chatReport = response.chatReport;
      this.checkoutReport = response.checkoutReport;
      this.automationReport = response.automationReport;
      this.urlReport = response.urlReport;
      this.isLoading = false;
    },
    gotoAutomation() {
      if (window.appBridgeApp) {
        const redirect = Redirect.create(window.appBridgeApp);
        redirect.dispatch(Redirect.Action.APP, "/automation");
      } else {
        this.$router.push({ name: "FullyAutomated" });
      }
    }
  }
};
</script>

<style lang="scss">
.input-date {
  border-radius: 4px;
  font-size: 13px !important;
  font-family: inter;
  font-weight: 400;
}
.daterangepicker .calendars {
  display: flex;
}
.reportrange-text {
  border-radius: 4px;
}
</style>
